/**
 * Centralized copy for the Customer Information detail page header. Kept out
 * of the component per the repo rule that feature text is not hardcoded inline
 * (mirrors MemberBooksTab.strings.ts).
 */
export const customerDetailStrings = {
  header: {
    // `customer.chargifyId` is a legacy field name: it holds the Chargebee
    // customer id.
    chargebeeCustomerId: "Chargebee customer ID",
    ghlSubdomain: "GHL book page subdomain",
    ghlStatusHint: "GHL account provisioning status",
    none: "—",
    // "Account manager: {name} · Change" (abo-account-manager-assignment
    // task 04); the select and its toasts share the list's copy.
    accountManager: {
      label: "Account manager",
      change: "Change",
      cancel: "Cancel",
    },
    // The one-click password row (ADR-001). Refusals point to the Security
    // tab, where the set-password section lives.
    password: {
      label: "Password",
      masked: "••••••••",
      reveal: "Reveal",
      hide: "Hide",
      copy: "Copy",
      autoHideNote: "Hidden again after 30 seconds.",
      staleBadge: "May be outdated",
      autoGeneratedBadge: "Looks auto-generated",
      copied: "Password copied to clipboard",
      copiedStale:
        "Password copied — it was captured before the member's last password change and may not work.",
      copyFailed: "Could not copy the password. Use Reveal instead.",
      copyUnavailable: "Copy needs a secure (https) page with clipboard access.",
      inactive: "This member is not active — password actions are disabled.",
      noOperator:
        "Your operator e-mail could not be resolved. Sign out and sign in again.",
      noOperatorToken:
        "Your sign-in could not be read. Sign in again to reveal passwords.",
      signInAgain: "Sign in again",
      error: "Could not get the password. Please try again.",
      refusals: {
        PASSWORD_REVEAL_OPERATOR_UNVERIFIED:
          "Please sign in again to reveal passwords.",
        PASSWORD_NOT_STORED:
          "No password is stored for this member. Set a new one in the Security tab.",
        MEMBER_NOT_FOUND: "This member was not found in DigitalServices.",
        PASSWORD_REVEAL_OPERATOR_NOT_ADMIN:
          "Only a DigitalServices administrator can reveal a member's password.",
        PASSWORD_REVEAL_TARGET_EXCLUDED:
          "The password of a staff account is never revealed.",
        rateLimitedOperator:
          "You reached your limit of password reveals for this hour. Try again later.",
        rateLimitedTarget:
          "This member's password was revealed too many times in the last hour. Try again later.",
        PASSWORD_VAULT_UNAVAILABLE:
          "The password vault is not available right now. Try again later.",
        PASSWORD_REVEAL_AUDIT_FAILED:
          "The request could not be recorded in the audit log, so the password was not returned. Try again.",
        PASSWORD_VAULT_OPEN_FAILED:
          "The stored password could not be opened. Set a new one in the Security tab.",
      },
    },
  },
} as const;
